import { CreditCard, Sparkles, LifeBuoy, HelpCircle } from "lucide-react";
import { ACCESOS } from "@/components/asistente/respuestasRapidas";

const ICONOS = { planes: CreditCard, funciones: Sparkles, faq: HelpCircle, soporte: LifeBuoy };

export function AccesosRapidos({ onElegir, disabled }) {
  return (
    <div className="flex flex-wrap gap-1.5 animate-in fade-in-0 slide-in-from-bottom-1 duration-300" data-testid="asistente-accesos">
      {ACCESOS.map(({ id, label }) => {
        const Icon = ICONOS[id];
        return (
          <button key={id} type="button" disabled={disabled} onClick={() => onElegir(id, label)}
            className="inline-flex items-center gap-1.5 rounded-full border border-[#00B4CC]/40 bg-white px-3 py-1.5 text-xs font-semibold text-[#007A8A] hover:bg-[#00B4CC]/10 hover:border-[#00B4CC] active:scale-95 transition-[background-color,border-color,transform] disabled:opacity-50"
            data-testid={`asistente-acceso-${id}`}>
            <Icon className="w-3.5 h-3.5" /> {label}
          </button>
        );
      })}
    </div>
  );
}
